import React, { useMemo } from "react";
import { Checkbox } from "@mui/material";
import {
	CustomButton,
	CustomTableCell,
	CustomTableRow,
	icon,
	VerticalDivider,
} from "../../../../../../common/components";
import { isNonEmptyArray } from "../../../../../../common/utils";
import { translate } from "../../../../../../common/providers";
import styles from "../TableRow.module.css";

const BulkTableHeaderRow = ({
	activeSort,
	direction,
	isChecked,
	isIndeterminate,
	onSelectAll,
	onConfirm,
	onInverse,
	onReject,
	onSort,
	onValidate,
	selectedCount,
}) => {
	const headers = useMemo(
		() => [
			{
				dataKey: "oldDocUploaded",
				id: 1,
				name: translate("document-center.table.bulk-versioning-dialog.table.import-date"),
				className: `${styles.cell} ${styles.headerCell} ${styles["cell--greyed"]} ${styles["cell__width--date"]}`,
			},
			{
				dataKey: "oldDocName",
				id: 2,
				name: translate("document-center.table.bulk-versioning-dialog.table.old-version"),
				className: `${styles.cell} ${styles.headerCell} ${styles["cell--greyed"]} ${styles["cell__width--text"]}`,
			},
			{
				dataKey: "newDocUploaded",
				id: 3,
				name: translate("document-center.table.bulk-versioning-dialog.table.import-date"),
				className: `${styles.cell} ${styles.headerCell} ${styles["cell__width--date"]}`,
			},
			{
				dataKey: "newDocName",
				id: 4,
				name: translate("document-center.table.bulk-versioning-dialog.table.new-version"),
				className: `${styles.cell} ${styles.headerCell} ${styles["cell__width--text"]}`,
			},
			{
				id: 5,
				name: "",
				className: `${styles.cell} ${styles.headerCell} ${styles["cell__width--60px"]}`,
				align: "center",
			},
			{
				id: 6,
				name: "",
				className: `${styles.cell} ${styles.headerCell} ${styles["cell__width--60px"]}`,
				align: "center",
			},
			{
				id: 7,
				name: translate("common:btn.confirm"),
				className: `${styles.cell} ${styles.headerCell} ${styles["cell__width--action"]}`,
				align: "center",
			},
			{
				id: 8,
				name: translate("document-center.table.bulk-versioning-dialog.table.reject"),
				className: `${styles.cell} ${styles.headerCell} ${styles["cell__width--action"]}`,
				align: "center",
			},
			{
				id: 9,
				name: translate("document-center.table.row.to-validate"),
				className: `${styles.cell} ${styles.headerCell} ${styles["cell__width--action"]}`,
				align: "center",
			},
		],
		[]
	);
	return (
		<CustomTableRow>
			<CustomTableCell
				align="center"
				className={`${styles.cell} ${styles.headerCell} ${styles["cell__width--48px"]}`}
			>
				<Checkbox checked={isChecked} indeterminate={isIndeterminate} onClick={onSelectAll} />
			</CustomTableCell>
			{(selectedCount > 0 && (
				<CustomTableCell className={`${styles.cell} ${styles.headerCell}`} colSpan={9}>
					<div className={styles.selectionHeader}>
						<span>
							{translate(
								selectedCount === 1
									? "document-center.table.bulk-versioning-dialog.table.selection"
									: "document-center.table.bulk-versioning-dialog.table.selections",
								{ count: selectedCount }
							)}
						</span>
						<div>
							<VerticalDivider className={styles.seperator} />
						</div>
						<span className={styles.actions}>{translate("common:add-template-panel.actions")}</span>
						<CustomButton
							color="secondary"
							size="sm"
							startIcon={icon.faArrowRightArrowLeft}
							variant="outlined"
							onClick={onInverse}
						>
							{translate("document-center.table.bulk-versioning-dialog.table.inverse")}
						</CustomButton>
						<CustomButton
							color="secondary"
							size="sm"
							startIcon={icon.faCheck}
							variant="outlined"
							onClick={onConfirm}
						>
							{translate("common:btn.confirm")}
						</CustomButton>
						<CustomButton
							color="secondary"
							size="sm"
							startIcon={icon.faTimes}
							variant="outlined"
							onClick={onReject}
						>
							{translate("document-center.table.bulk-versioning-dialog.table.reject")}
						</CustomButton>
						<CustomButton
							color="secondary"
							size="sm"
							startIcon={icon.faExclamationTriangle}
							variant="outlined"
							onClick={onValidate}
						>
							{translate("document-center.table.row.to-validate")}
						</CustomButton>
					</div>
				</CustomTableCell>
			)) || (
				<>
					{isNonEmptyArray(headers) &&
						headers.map((header) => (
							<CustomTableCell
								key={header.id}
								active={activeSort === header.dataKey && direction?.toLowerCase()}
								align={header.align}
								className={header.className}
								direction={direction?.toLowerCase()}
								sortKey={header.disableSort ? null : header.dataKey}
								onSort={() => onSort(header.dataKey)}
							>
								{header.name}
							</CustomTableCell>
						))}
				</>
			)}
		</CustomTableRow>
	);
};

export default BulkTableHeaderRow;
